import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { sarsaparillaReducers } from 'sarsaparilla';
import parkpassReducers from '../src/reducers';
import { cartItemsReducers as cart } from '../../ui-cart';

const reducers = {
  routing: routerReducer,
  ...sarsaparillaReducers,
  parkpass: parkpassReducers,
  cart
};

export default combineReducers(reducers);

